import { useMemo } from 'react';

import { IModules, IPersonalizedPage } from '~/lib/data-contract';
import { isSSR } from '~/shared/utils/platform/utils/platform';
import { useGetRequest } from '~/shared/utils/request/hooks/useGetRequest';

type UsePersonalizedContentReturnFormat = {
	loaded: boolean;
	error?: boolean;
	content: IModules | undefined;
};

export const usePersonalizedContent = (id: string): UsePersonalizedContentReturnFormat => {
	const { pathname = '', search = '' } = !isSSR ? window.location : ({} as never);
	const url = pathname + search;

	const { data, isFetched, isError } = useGetRequest<IPersonalizedPage>('/api/proxy/content/personalizedpage', {
		params: { url },
		enabled: !isSSR,
	});

	return useMemo(
		() => ({
			loaded: isFetched,
			error: isError,
			content: data?.pageElements.find((item) => item.id === id) as IModules | undefined,
		}),
		[data?.pageElements, id, isFetched, isError],
	);
};
